import { render } from "./HeadlessFileInput.vue?vue&type=template&id=6e36b3a2"
import script from "./HeadlessFileInput.vue?vue&type=script&lang=js"
export * from "./HeadlessFileInput.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__